import { createSelector } from 'reselect';

const getAIAssistantState = state => state.aiAssistant;

export const getIsVisible = createSelector(
  [getAIAssistantState],
  aiAssistant => aiAssistant.isVisible
);

export const getIsCollapsed = createSelector(
  [getAIAssistantState],
  aiAssistant => aiAssistant.isCollapsed
);

export const getContext = createSelector(
  [getAIAssistantState],
  aiAssistant => aiAssistant.context
);

export const getMessages = createSelector(
  [getAIAssistantState],
  aiAssistant => aiAssistant.messages
);

export const getConversationId = createSelector(
  [getAIAssistantState],
  aiAssistant => aiAssistant.conversationId
);

export const getIsTyping = createSelector(
  [getAIAssistantState],
  aiAssistant => aiAssistant.isTyping
);

export const getPendingAction = createSelector(
  [getAIAssistantState],
  aiAssistant => aiAssistant.pendingAction
);

export const getError = createSelector(
  [getAIAssistantState],
  aiAssistant => aiAssistant.error
);

export const getHasMessages = createSelector(
  [getMessages],
  messages => messages.length > 0
);

export const getLastMessage = createSelector(
  [getMessages],
  messages => messages.length > 0 ? messages[messages.length - 1] : null
);
